export default __webpack_public_path__ + "static/andrea-hennige-a883646ad9d85a4688c940fbab0192a0.jpg";